<template>
  <div class="bgMesurement_ctn" :class="{ h82, isFromPumpReport }" :style="{ zoom, marginTop: (isDaily ? '0px' : `35px`), width: `${width}px`, fontSize: 20 + 'px' }">
    <div class="bgMesurement_titleRow bgMesurement_titleRow--top roundedCorner-t-l roundedCorner-t-r">
      {{ $t('Number of BG measurements') }}
    </div>  
    <div class="bgMesurement_descriptionRow">
      <div class="bgMesurement_descriptionRow--label">
        {{ $t('Per day') }}
      </div>
      <div class="bgMesurement_descriptionRow--content">
        {{ value.bgPerDay }}
      </div>
      <div class="bgMesurement_descriptionRow--label">
        {{ $t('Total') }}
      </div>
      <div class="bgMesurement_descriptionRow--content">
        {{ bgTotal }}
      </div>
    </div>    
    <!-- <div class="bgMesurement_titleRow"> -->
    <!--   {{ isFromPumpReport ? $t('Glycemia Mean(for pump report)') : $t('Glycemia Mean') }} -->
    <!-- </div> -->
    <div class="bgMesurement_titleRow">
      {{ $t('Glycemia Mean') }}
    </div>
    <div class="bgMesurement_descriptionRow">
      <div class="bgMesurement_descriptionRow--label">
        {{ $t('BG Mean') }}
      </div>
      <div class="bgMesurement_descriptionRow--content">
        {{ value.bgMean }}
      </div>
      <div class="bgMesurement_descriptionRow--label">
        {{ $t('CGM Mean') }}
      </div>
      <div class="bgMesurement_descriptionRow--content">
        {{ value.cgmMean }}
      </div>
    </div>
    <div v-show="!isDaily" class="bgMesurement_descriptionRow">
      <div class="bgMesurement_descriptionRow--label" :class="{'bgMesurement_descriptionRow--label4': isFromPumpReport}">
        {{ $t('Days between Reservoir Change') }}
      </div>
      <div class="bgMesurement_descriptionRow--content">
        {{ value.reseviorChangePerDay }}
      </div>
    </div>
    <!-- <div class="bgMesurement_titleRow"> -->
    <!--   {{ $t('Number of Bolus per day') }} -->
    <!-- </div> -->
    <div class="bgMesurement_descriptionRow">
      <div class="bgMesurement_descriptionRow--label" :class="{ 'bgMesurement_descriptionRow--label4': isFromPumpReport }">
        {{ $t('Number of Bolus per day') }}
      </div>
      <div class="bgMesurement_descriptionRow--content">
        {{ value.bolusPerDay }}
      </div>
      <!-- <div class="bgMesurement_descriptionRow--label"> -->
      <!--   {{ $t('Total') }} -->
      <!-- </div> -->
      <!-- <div class="bgMesurement_descriptionRow--content"> -->
      <!--   {{ value.bolusTotalCount }} -->
      <!-- </div> -->
    </div>
    <div class="bgMesurement_descriptionRow">
      <div class="bgMesurement_descriptionRow--label" :class="{ 'bgMesurement_descriptionRow--label4': isFromPumpReport }">
        {{ isFromPumpReport ? $t('Carbonhydrate Total') : $t('Carbonhydrate Total') }}
      </div>
      <div class="bgMesurement_descriptionRow--content">
        {{ value.carbohydrTotal }}
      </div>
    </div>
    <div class="bgMesurement_descriptionRow bgMesurement_descriptionRow--noTitle">
      <div class="bgMesurement_descriptionRow--label" :class="{ 'bgMesurement_descriptionRow--label4': isFromPumpReport }">
        <!-- {{ $t('boluses of using bolus calculator %') }} -->
        {{ $t('Boluses with Bolus Calculator %') }}
      </div>
      <div class="bgMesurement_descriptionRow--content">
        {{ value.calculatorBolusPercent }}
      </div>      
    </div>
    <div class="bgMesurement_descriptionRow bgMesurement_descriptionRow--noTitle roundedCorner-b-l roundedCorner-b-r">
      <div class="bgMesurement_descriptionRow--label roundedCorner-b-l" :class="{ 'bgMesurement_descriptionRow--label4': isFromPumpReport }">
        {{ $t('Percentage of boluses when the patients disagree with Bolus Calculator suggestion') }}
      </div>
      <div class="bgMesurement_descriptionRow--content  roundedCorner-b-r">
        {{ value.disagreePercent }}
      </div>      
    </div>
  </div>
</template>
<script>
import reDrawTrigger from '@mx/reDrawTrigger'

export default {
  name: 'CTableBGMesurement',
  mixins: [reDrawTrigger],
  props: {
    isDaily: {
      type: [Boolean],
      default: false
    },
    dailyTotal: {
      type: [Number, String],
      default: ''
    },
    h82: {
      type: [Boolean, String, Number],
      default: false
    },
    width: {
      type: [String, Number],
      default: 455
    },
    value: {
      type: [Object],
      default: () => {}
    }
  },
  data() {
    return {      
    }
  },
  computed: {
    isFromPumpReport() {
      const { h82 } = this
      return !!h82
    },
    bgTotal() {
      const { isDaily, dailyTotal, value = {}} = this
      return isDaily ? dailyTotal : value.bgTotal
    },
    zoom() {
      const { zoomRatio = 1, width, body21CmRatio = 1200 } = this
      const limit = Math.max(Math.ceil(body21CmRatio / 2), 780)
      if (width - limit <= 0) {
        return zoomRatio * 0.8
      } else {
        return zoomRatio
      }
    }
  },
  mounted() {
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
@import '@/styles/mixin';
@import '@/styles/variables';

$rowH: 44px;
$rowH2: 74px;
.bgMesurement_ctn {
    color: $colorGluMesurementFont;
    /* font-weight: 600; */
    font-size: $sizeFontSize;
    display: inline-block;
    @include bBox;
    .bgMesurement_titleRow {
        /* @include heightMiddle($rowH);         */
        min-height: $rowH;
        @include bBox;
        @include flexRow(flex-start, center);
    }
    &.h82 .bgMesurement_titleRow {
        /* @include heightMiddle($rowH2); */
        min-height: $rowH2;
    }
    .bgMesurement_titleRow, .bgMesurement_descriptionRow {        
        @include bBox;
        /* height: 44px; */
        /* overflow: hidden; */
        /* min-height: 44px; */
        border: 1px solid $colorGluMesurementInnerBorder;
        border-top-width: 0;
        /* border-bottom-width: 0; */
        text-indent: 7px;
        &.bgMesurement_titleRow--last {
            border-bottom: 1px solid $colorGluMesurementInnerBorder;
        }
        &.bgMesurement_titleRow--top {
            /* text-indent: 20px; */
            border-top-width: 1px;
            /* border-bottom-width: 1px; */
        }
    }
    &.h82 .bgMesurement_descriptionRow .bgMesurement_descriptionRow--label, .bgMesurement_descriptionRow--content {
        min-height: $rowH2;
        text-indent: 0;
    }
    .bgMesurement_descriptionRow {
        @include flexRow(space-evenly, stretch);
        .bgMesurement_descriptionRow--label, .bgMesurement_descriptionRow--content {
            @include bBox;
            flex-grow: 1;
            flex-shrink: 1;
            /* height: 100%; */
            min-height: $rowH;
            width: 25%;
            @include flexColumn(center, flex-start);
        }
        .bgMesurement_descriptionRow--content {
            align-items: center;
        }
        .bgMesurement_descriptionRow--content{
            font-size: 0.8em;
        }
        .bgMesurement_descriptionRow--label {
            background-color: $colorGluMesurementLabelBg;
            color: $colorGluMesurementFont;
            padding: 0 5px;
            text-indent: 0;
            
            &.bgMesurement_descriptionRow--label2 {
                width: 25%;
                flex-grow: 0;
                font-size: 0.92em;
            }
            &.bgMesurement_descriptionRow--label3 {
                width: calc(263 / 455) * 100%;
                flex-grow: 0;
                font-size: 1em;
            }
        }
    }
    
    &.isFromPumpReport {
        .bgMesurement_descriptionRow--label {
            width: 60%;
            &.bgMesurement_descriptionRow--label4 {
                width: 100%;
            }
        }
    }
}
</style>
